module.exports = __webpack_public_path__ + "media/images/favicons/192x192-1cbd9d01af748e0fcd04d3aa35a674cb.png";